import React, { useState } from "react";
import { CellTmpl, TitleTmpl, reactFormatter } from "../../../common/Table";
import RuleDetails from "./RuleDetails";
import { useDeleteRule, useGetRules } from "../../../../backend/masters";
import { GetMastersBreadcrumb, RuleType } from "../Master.constants";
import { useExportRules } from "../../../../backend/exports";
import BaseList from "../../../common/BaseList";
import { RuleSchema } from "../../../../models/rule";
import AddEditRule from "./AdEditRule";
import RulesImportModal from "./RulesImportModal";

function Rule() {
    const [breadcrumb] = useState(GetMastersBreadcrumb('Rule'));
    
    const columns = [
        {
            title: "Name", field: "name", widthGrow: 2,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Description", field: "description", widthGrow: 2,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Type", field: "rule_type", width: 140,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Section No.", field: "section_no", minWidth: 140,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Rule No.", field: "rule_no", minWidth: 140,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Unique Identifier", field: "unique_identifier",
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        }
    ];

    const filterConfig = [
        {
            label: 'Type',
            name: 'rule_type_eq',
            options: [{ value: "", label: "Blank" }, ...RuleType.map(x => {
                return { value: x, label: x };
            })]
        }
    ]

    return (
        <BaseList
            fetchData={useGetRules}
            exportData={useExportRules}
            deleteData={useDeleteRule}
            nameAttribute={'name'}
            columns={columns}
            DetailView={RuleDetails}
            FormView={AddEditRule}
            modelSchema={RuleSchema}
            initialSort={['name asc']}
            breadcrumb={breadcrumb}
            ImportComponent={RulesImportModal}
            filterConfig={filterConfig}
            title="Mastsers - Rules"
        />
    )
}

export default Rule;
